"use client";
import React, { useState } from "react";

function Intro({ title="", description, className = "" }) {
    return (
        <section className={` text-black space-y-2 ${className}`}>
            <h2
                className="text-2xl sm:text-3xl lg:text-[42px] font-saansBold mt-6 md:mt-14 lg:mt-16 "
            >
                {title}
            </h2>
            {description && (
                <div className="mb-8 text-base sm:text-lg lg:text-[18px] max-w-5xl">
                    {description}
                </div>
            )}
        </section>
    );
}
export default Intro;
